import { Component, Input } from '@angular/core';
import { ScansInterface } from '@monsido/modules/models/api/interfaces/scans.interface';

@Component({
    selector: 'mon-request-checker-advance-component',
    templateUrl: 'advance.html',
    standalone: false,
})

export class AdvanceComponent {
    @Input() url: string;
    @Input() scan: ScansInterface;
    constructor () {}
}
